/* eslint-disable no-nested-ternary */
import { ArrowBackIcon, ArrowForwardIcon } from "@chakra-ui/icons";
import { Button, Flex } from "@chakra-ui/react";
import useMediaQ from "@root/hooks/useMediaQ";
import { testId as testIdFn } from "@utils/e2e";

export const Paginate = (props: PaginateProps) => {
  const {
    count,
    pageSize,
    page,
    view,
    onPageChange,
    size = "sm",
    selectedVariant = "outline",
    variant = "ghost",
    previousIcon = <ArrowBackIcon boxSize="5" color="#8B94A2" />,
    nextIcon = <ArrowForwardIcon boxSize="5" color="#8B94A2" />,
    fontWeight = "light",
    borderRadius = "sm",
    isRtl = false,
    id,
    ...rest
  } = props;

  const numberOfPages = Math.ceil(count / pageSize);
  const { md } = useMediaQ();

  const handlePageClick = (i: number) => {
    let newPage = i;

    if (i >= numberOfPages) {
      newPage = numberOfPages;
    } else if (i <= 0) {
      newPage = 1;
    }

    onPageChange(newPage, view, id);
  };

  const shouldRender = (idx: number) =>
    idx === page ||
    (idx >= page - 2 && idx <= page + 2 && md) ||
    (idx === 1 && md) ||
    (idx === numberOfPages && md);

  const shouldRenderEllipsis = (idx: number) =>
    (idx === page + 3 && idx !== numberOfPages) ||
    (idx === page - 3 && idx !== 1);

  const showPagination = numberOfPages > 1;
  const showPreviousButton = showPagination && page > 1;
  const showNextButton = showPagination && page < numberOfPages;

  if (!showPagination) {
    return null;
  }

  return (
    <Flex flexWrap={"wrap"} width="fit-content">
      {showPreviousButton && (
        <Button
          {...rest}
          fontWeight={fontWeight}
          borderLeftRadius="10px"
          width="40px"
          height="40px"
          border="1px solid #CDD6DC"
          variant={variant}
          aria-label="previous"
          leftIcon={isRtl ? nextIcon : previousIcon}
          onClick={(e) => {
            e.preventDefault();
            handlePageClick(page - 1);
          }}
          disabled={page === 1}
        >
          {""}
        </Button>
      )}
      {Array(numberOfPages)
        .fill(0)
        .map((_, i) => {
          if (shouldRender(i + 1)) {
            return (
              <Button
                key={i}
                {...rest}
                fontWeight={fontWeight}
                borderRadius={borderRadius}
                width="40px"
                height="40px"
                bg={page === i + 1 ? "gray.100" : "transparent"}
                
                borderColor={page === i + 1 ? "blue.500" : "#CDD6DC"}
                borderWidth={page === i + 1 ? "2px" : "1px"}
                color={page === i + 1 ? "blue.500" : "inherit"}
                _hover={{ color: "blue.500" }}
                {...testIdFn(`pagination-page-${i + 1}`)}
                onClick={(e) => {
                  e.preventDefault();
                  handlePageClick(i + 1);
                }}
              >
                {i + 1}
              </Button>
            );
          } else if (shouldRenderEllipsis(i + 1)) {
            return (
              <Button
                key={i}
                {...rest}
                fontWeight={fontWeight}
                borderRadius={borderRadius}
                width="40px"
                height="40px"
                border="1px solid #CDD6DC"
                variant={variant}
                pointerEvents="none"
              >
                ...
              </Button>
            );
          }

          return null;
        })}
      {showNextButton && (
        <Button
          {...rest}
          fontWeight={fontWeight}
          border="1px solid #CDD6DC"
          borderRightRadius="10px"
          aria-label="next"
          rightIcon={isRtl ? previousIcon : nextIcon}
          onClick={(e) => {
            e.preventDefault();
            handlePageClick(page + 1);
          }}
          width="40px"
          height="40px"
          variant={variant}
          disabled={page === numberOfPages}
        >
          {" "}
        </Button>
      )}
    </Flex>
  );
};
